import React, { useCallback, useEffect, useRef, useState } from "react";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { ShieldCheck } from "lucide-react";
import {
  Box,
  Button,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TableContainer,
  Paper,
  IconButton,
  styled,
  SelectChangeEvent,
  useTheme,
  Theme,
  TextField,
} from "@mui/material";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import DeleteIcon from "@mui/icons-material/Delete";
import CloseIcon from "@mui/icons-material/Close";
import { axiosInstance } from "../../utility/apiInstance";
import Select from "react-select";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
} from "@mui/material";
import toast from "react-hot-toast";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { isAxiosError } from "axios";
import { he, tr } from "date-fns/locale";
import { set } from "date-fns";


const defaultTheme = createTheme();

interface BulkUploadAWBNumberProps {
  setShowAirBulk: React.Dispatch<React.SetStateAction<boolean>>;
}
const BulkUploadAWB: React.FC<BulkUploadAWBNumberProps> = ({ setShowAirBulk }) => {
  const newController = new AbortController();
  const [fileName, setFileName] = useState<string | null>(null);
  const [file, setFile] = useState<File | null>(null);
  const [tableData, setTableData] = useState<any[]>([]);
  const [showButton, setShowButton] = useState(true);
  const [errors, setErrors] = useState<any[]>([]);
  const [error, setError] = useState("");
  const [popupOpen, setPopupOpen] = useState(false);
  const [selectedCell, setSelectedCell] = useState({
    header: "",
    value: "",
    index: 0,
  });
  const [selectedRow, setSelectedRow] = useState<any | null>(null);
  const [popupError, setPopupError] = useState<string | null>(null);
  const [successPoppup, setSuccessPoppup] = useState(false);
  const [errorPoppup, setErrorPoppup] = useState(false);
  const [failedPoppup, setFailedPoppup] = useState([]);
  const [csvBulkShow, setCsvBulkShow] = useState({
    milestoneList: "[]",
    manageContactList: "[]",
    selectedWhatsappMilestones: "[]",
    selectedEmailMilestones: "[]",
    selectedWhatsapp: "[]",
    selectedEmail: "[]",
    selectedTag: "[]",
    selectedWhatsappGroupName: "[]",
    selectedWhatsappGroupMilestones: "[]",
    tagList: "",
  }) as any;
  
  const [csvTemplate, setCsvTemplate] = useState<string[]>([
    "AWB",
    "Template",
    "WhatsappMilestones",
    "EmailMilestones",
    "Whatsapp",
    "Email",
    // "Tag",
    "WhatsappGroupName",
    "WhatsappGroupMilestones",
    "GroupingMilestone",
  ]);
  const apiControllerRef = useRef<AbortController | null>(null);
  const [editable, setEditable] = useState(false);
  const [isEditable, setIsEditable] = useState(false);
  const [showError, setShowError] = useState("");
  const [awbSubscriptionTemplate, setAwbSubscriptionTemplate] = useState(false);
  const cancelRequest = useRef(false);
  const [showtable, setShowtable] = useState(0);
  const VisuallyHiddenInput = styled("input")({
    clip: "rect(0 0 0 0)",
    clipPath: "inset(50%)",
    height: 1,
    overflow: "hidden",
    position: "absolute",
    bottom: 0,
    left: 0,
    whiteSpace: "nowrap",
    width: 1,
  });
  const [allField, setAllField] = useState([]);
  const [dropdownField, setDropdownField] = useState<any>([]);
  const [custommFieldTypeIsDropdown, setCustommFieldTypeIsDropdown] = useState(false);
  const [currentFieldType, setCurrentFieldType] = useState("");

  function getdropdownField(fieldName: any) {
    const fieldData: any = allField.find((field: any) => field.fieldName === fieldName);
    setDropdownField(fieldData?.dropdownOptions || []);
  }
  useEffect(() => {
    let interval = 0 as any;
    if (selectedCell) {
      interval = setTimeout(() => {
        handleVerify(selectedCell);
      }, 1000);
    }
    return () => {
      clearInterval(interval);
      newController.abort();
    };
  }, [selectedCell, csvBulkShow]);

  useEffect(() => {
    if (!popupOpen) {
      if (apiControllerRef.current) {
        newController.abort();


      }
      cancelRequest.current = false;
      setShowError("");
    }
  }, [popupOpen]);

  const handleFileChange = useCallback(
    (event: any) => {
      const selectedFile = event.target.files[0];
      if (selectedFile) {
        setFile(selectedFile);
        setFileName(selectedFile.name);
        setShowButton(true);
      }
    },
    [file]
  );



  const getCustomForms = async () => {
    try {
      const allFields = await axiosInstance.get('/api/v1/custom-form/admin-fields');
      setAllField(allFields.data.data);

      // Extract field names
      const customFieldNames = allFields.data.data.map((item: any) => item.fieldName);

      // Append new fields without duplicates
      setCsvTemplate((prev: string[]) => Array.from(new Set([...prev, ...customFieldNames])));

    } catch (error: any) {
      throw error;
    }
  };

  const handleDeleteRow = (index: number) => {
    const newData = tableData.filter((_, i) => i !== index);
    setTableData(newData);

  };

  const handleReadClick = async (buttonValue: string | Blob) => {
    try {
      let params = {} as any;
      const formData = new FormData();
      if (file && buttonValue === "") {
        formData.append("file", file);
        params = formData;
      } else {
        params = {
          data: tableData,
          prompt: buttonValue,
        };
      }
      const { data } = await axiosInstance.post(
        `/api/v1/file/file-upload`,
        params,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
      setFile(null);
     
      const tableList = data?.data?.map((item: any) => {
        const errorStatusFields = csvTemplate.reduce((acc: any, key: string) => {
          acc[`errorStatus${key}`] = null;
          return acc;
        }, {});

        return {
          ...item,
          ...errorStatusFields,
        };
      });
      if (data.isPopUp && buttonValue === "") {
        setTableData(tableList);
        setAwbSubscriptionTemplate(false);
        return false;
      } else if (!data.isPopUp && buttonValue === "") {
        setTableData(tableList);
        setShowButton(false);
        setErrors([]);
        setShowtable(1);
        setAwbSubscriptionTemplate(false);
        return true;
      } else {
        setTableData(tableList);
        setShowButton(false);
        setErrors([]);
        setShowtable(1);
        setAwbSubscriptionTemplate(false);
      }
    } catch (error: any) {
      setAwbSubscriptionTemplate(false);
      const errorMessage = error.response?.data?.error || "File upload failed!";
      toast.error(errorMessage);
      return null;
    }
  };



  const handleVerifyAndUploadClick = async () => {
    try {
      const response= await axiosInstance.post(
        `/api/v1/file/create-bulk-subcription`,
        { data: tableData },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      const {data} = response;

      const errorData = data.data || [];
      let arrayList = [...tableData];
      const validKeys = [...csvTemplate];

      // Mark errors dynamically
      for (let i = 0; i < errorData.length; i++) {
        for (let j = 0; j < arrayList.length; j++) {
          if (
            Object.keys(errorData[i]) != null &&
            +Object.keys(errorData[i])[0] === j
          ) {
            const errorValues = Object.values(errorData[i]).flat();

            Object.keys(arrayList[j]).forEach((key: string) => {
              const keyName = `errorStatus${key}`;
              if (validKeys.includes(key)) {
                arrayList[j][keyName] = errorValues?.includes(key) ? "1" : "0";
              }
            });
          }
        }
      }

      // Initialize any undefined errorStatus fields dynamically
      arrayList = arrayList.map((item: any) => {
        validKeys.forEach((key) => {
          const keyName = `errorStatus${key}`;
          if (item[keyName] === null || item[keyName] === undefined) {
            item[keyName] = "0";
          }
        });
        return item;
      });

      setTableData(arrayList);
      setErrors(data.data);
      
      if (Array.isArray(data?.data) && data?.data?.length > 0) {
        const firstErrorObj = data?.data?.find((obj: any) => obj && Object.keys(obj).length);
        if (firstErrorObj) {
          const [[row, fields]] = Object.entries(firstErrorObj);
          const [field] = fields as string[];
          const rows = Number(row) + 1 || 1;
          if (fields == "AWB") {
            toast.error(`Row ${rows}: ${field} is invalid or Empty it should be (123-45678983) in this format`);
          } else {
            toast.error(`Row ${rows}: ${field} is invalid or Empty`);
          }
        }
      }
      
      const messageStatus = data?.message?.messageStatus;
      if (messageStatus === 1 || messageStatus === "") {
        setSuccessPoppup(true);
        handleRemoveFile();
      } else if (messageStatus === 2) {
        setError(data?.message?.message);
        setFailedPoppup(data.data.failed);
        setErrorPoppup(true);
      }
    } catch (error: any) {
      const errorMessage = error.response?.data?.error || "Verification failed!";
      toast.error(errorMessage);
    }
  };
  const handleRemoveFile = () => {
    setFileName(null);
    setFile(null);
    setTableData([]);
    setErrors([]);
    setShowButton(true);
    setShowtable(0);
  };

  const handleOpenPopup = async (
    row: any,
    headerName: string,
    cellValue: string,
    errorMessage: string | null,
    rowIndex: number
  ) => {
    cancelRequest.current = true;

    setShowError("");
    setSelectedCell({ header: headerName, value: cellValue, index: rowIndex });
    setCsvBulkShow((prev: any) => ({
      ...prev,
      type: headerName,
      [`selected${headerName}`]: cellValue?cellValue
        ?.split(",")
        ?.map((item) => ({ label: item, value: item })):[],
    }));

    const fieldData: any = allField.find((field: any) => field.fieldName === headerName);
    setCurrentFieldType(fieldData?.fieldType);
    if (fieldData && fieldData?.fieldType == "Dropdown List") {
      setCustommFieldTypeIsDropdown(true);
    }

    setSelectedRow(row);
    setPopupError(errorMessage);
  };

  const handleVerify = useCallback(
    async (celldata: any) => {
      const { header, index, value: awbData } = celldata;
      if (apiControllerRef.current) {
        apiControllerRef.current.abort();
      }
      apiControllerRef.current = newController;
      const { type } = csvBulkShow;

      let selectedData = `selected${type}` as any;

      let value = Array.isArray(csvBulkShow[selectedData]) ? csvBulkShow[selectedData]?.map((item: any) => item?.value).join(",") : csvBulkShow[selectedData]?.value;
      if (currentFieldType == "Number" || currentFieldType == "Text Box" || currentFieldType == "Date") {
        value = selectedCell?.value
      }

      try {

        setShowError("");

        let data;
        switch (header) {
          case "AWB":
              data = await axiosInstance.post(`/api/v1/file/verify-awbNumber`, {
              signal: newController.signal,
              AWB: awbData,
            });
            break;

          case "WhatsappMilestones":
            data = await axiosInstance.post(`/api/v1/file/verify-milestone`, {
              signal: newController.signal,
              Milestones: value,
            });
            break;

          case "WhatsappGroupMilestones":
            data = await axiosInstance.post(`/api/v1/file/verify-milestone`, {
              signal: newController.signal,
              Milestones: value,
            });
            break;

          case "EmailMilestones":
            data = await axiosInstance.post(`/api/v1/file/verify-milestone`, {
              signal: newController.signal,
              Milestones: value,
            });
            break;

          case "Email":
            data = await axiosInstance.post(`/api/v1/file/verify-contacts`, {
              signal: newController.signal,
              contacts: value,
              channel: "email",
            });
            break;

          case "Whatsapp":
            data = await axiosInstance.post(`/api/v1/file/verify-contacts`, {
              signal: newController.signal,
              contacts: value,
              channel: "whatsapp",
            });
            break;

          case "WhatsappGroupName":
            data = await axiosInstance.post(
              `/api/v1/file/verify-whatsappGroupName`,
              {
                signal: newController.signal,
                WhatsappGroupName: value,
              }
            );
            break;

          case "Tag":
            data = await axiosInstance.post(`/api/v1/ocean/bulk/verify-tag`, {
              signal: newController.signal,
              tag: value,
            });
            break;
          case "GroupingMilestone":
            data = await axiosInstance.post(`/api/v1/file/verify-milestone-groupping`, {
              signal: newController.signal,
              GroupingMilestone: value,
            });
            break;

          default:
            {
              if (!header) {
                return;
              } else {

                data = await axiosInstance.post(`/api/v1/file/verify-custom-fields`, {
                  signal: newController.signal,


                  "CustomField": header,
                  "customFieldValue": value

                }
                );

              }
            };
        }

        setTableData((prev: any) => {
          let array = [...prev];
          array[index][`errorStatus${header}`] = "0";
          array[index][header] = header == "AWB" ? awbData : value;
          return array;
        });

        setShowError("");
        if (cancelRequest.current) {
          setPopupOpen(true);
        }

      } catch (error) {
        setTableData((prev: any) => {
          let array = [...prev];
          array[index][`errorStatus${header}`] = "true";
          array[index][header] = header == "AWB" ? awbData : value;
          return array;
        });
        if (cancelRequest.current) {
          setPopupOpen(true);
        }

        if (isAxiosError(error) && error.response && error.response.data) {
          const { message, data } = error.response.data;

          if (header === "Email" || header === "Whatsapp") {
            const validationErrors = data?.validationErrors || [];

            const errorMessages = validationErrors
              .map((error: any) => {
                return `${error.contact}: ${error.error}`;
              })
              .join(", ");

            const toastMessage = `${message}: ${errorMessages}`;
            setShowError(errorMessages);
          } else if (header === "WhatsappGroupName") {
            const invalidItems = data?.validateWhatsAppGroup || [];
            let errorMessages = "";

            const errorMessage = invalidItems
              .map((error: any) => {
                return error.error;
              })
              .join(", ");
            errorMessages = `WhatsappGroupName: ${errorMessage}`;
            setShowError(errorMessages);
          } else if (header === "WhatsappMilestones") {
            const invalidItems = data?.invalidMilestones || [];
            let errorMessage = "";

            if (invalidItems.length > 0) {
              errorMessage = `${message}: ${invalidItems.join(", ")}`;
            }
            setShowError(errorMessage);
          } else if (header === "WhatsappGroupMilestones") {
            const invalidItems = data?.invalidMilestones || [];
            let errorMessage = "";

            if (invalidItems.length > 0) {
              errorMessage = `${message}: ${invalidItems.join(", ")}`;
            }
            setShowError(errorMessage);
          } else if (header === "EmailMilestones") {
            const invalidItems = data?.invalidMilestones || [];
            let errorMessage = "";

            if (invalidItems.length > 0) {
              errorMessage = `${message}: ${invalidItems.join(", ")}`;
            }
            setShowError(errorMessage);
          } else if (header === "AWB") {
            const invalidItems = error.response.data.error || [];
            const errorMessage: any = [];
            invalidItems.forEach((element: any) => {
              errorMessage.push(`${element.awb} : ${element.reason}`);
            });
            setShowError(errorMessage.join(", "));
          } else if (header === "Tag") {
            const invalidItems = error.response.data.error || [];
            const errorMessage: any = [];
            invalidItems.forEach((element: any) => {
              if (element.tag) {
                errorMessage.push(`${element.tag}: ${element.reason}`);
              } else {
                errorMessage.push(`${element.reason}`);
              }
            });
            setShowError(errorMessage.join(", "));
          }


          else if (header === "GroupingMilestone") {
            const invalidItems = error.response.data.error || [];
            const errorMessage: any = [];
            invalidItems.forEach((element: any) => {
              if (element.GroupingMilestone) {
                errorMessage.push(`${element.GroupingMilestone}: ${element.reason}`);
              } else {
                errorMessage.push(`${element.reason}`);
              }
            });
            setShowError(errorMessage.join(", "));
          }

          else {
            // if(message){
            const invalidItems = error.response.data.error || [];
            const errorMessage: any = [];
            invalidItems.forEach((element: any) => {
              errorMessage.push(`${element.fieldName}: ${element.reason}`);

            });
            setShowError(errorMessage.join(", "));
          }
        } else {
          toast.error("An unexpected error occurred.");
          setShowError("No Error Found!");
        }
      }
    },
    [selectedCell, csvBulkShow]
  );

  const [personName, setPersonName] = React.useState<string[]>([]);

  const handleChange = (event: SelectChangeEvent<typeof personName>) => {
    const {
      target: { value },
    } = event;

    setPersonName(typeof value === "string" ? value.split(",") : value);
    setSelectedCell((prev: any) => ({ ...prev, value }));
  };

  const handleDelete = (valueToRemove: string) => {
    setPersonName((prevSelected) =>
      prevSelected.filter((value) => value !== valueToRemove)
    );
  };

  useEffect(() => {
    getBulkContactList();
    getBulkMileStone();
    getWhatsappGroup();
    getAllTag();
    getAllMilwAtoneGroupping();
    getCustomForms();
  }, []);

  const downloadCSV = () => {
    // Step 1: Extract headers
    const headers = csvTemplate

    // Step 2: Map data to CSV rows
    const csvRows = [
      headers.join(",")
    ];

    // Step 3: Create CSV string
    const csvString = csvRows.join("\n");

    // Step 4: Create blob and trigger download
    const blob = new Blob([csvString], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);

    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", "Air_bulk_upload.csv");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };
  const getBulkMileStone = async () => {
    try {
      let { data } = await axiosInstance.get("/api/v1/mileStone/bulk-custom-milestone");
      setCsvBulkShow((prev: any) => {
        return {
          ...prev,
          milestoneList: data?.data,
        };
      });
    } catch (err) { }
  };

  const getBulkContactList = async () => {
    try {
      let response = await axiosInstance.get("/api/v1/contact");
      setCsvBulkShow((prev: any) => {
        return {
          ...prev,
          manageContactList: response?.data?.data,
        };
      });
    } catch (err: any) { }
  };

  const getWhatsappGroup = async () => {
    try {
      let response = await axiosInstance.get("/api/v1/whatsapp-group");
      setCsvBulkShow((prev: any) => {
        return {
          ...prev,
          whatsappGroupList: response?.data?.data,
        };
      });
    } catch (err) { }
  };

  const getAllTag = async () => {
    try {
      let response = await axiosInstance.get("/api/v1/tag");
      setCsvBulkShow((prev: any) => {
        return {
          ...prev,
          tagList: response?.data?.data,
        };
      });
    } catch (err) { }
  };
  const getAllMilwAtoneGroupping = async () => {
    try {
      let response = await axiosInstance.get("api/v1/groupingMileStone?search&type=air");
      setCsvBulkShow((prev: any) => {
        return {
          ...prev,
          milestoneGrouppingList: response?.data?.data,
        };
      });
    } catch (err) { }
  };

  const handleSelectedCellData = () => {


    let { type, milestoneList, manageContactList, whatsappGroupList, tagList, milestoneGrouppingList } =
      csvBulkShow;
    let { header, value } = selectedCell;
    const headerCheck: any = allField.find((item: any) => item.fieldName === header);
    if (type === "AWB") {
      return;
    } else if (type === "WhatsappMilestones") {
      return milestoneList?.map((item: any) => ({
        label: item?.milestone,
        value: item?.milestone,
      }));
    } else if (type === "WhatsappGroupMilestones") {
      return milestoneList?.map((item: any) => ({
        label: item?.milestone,
        value: item?.milestone,
      }));
    } else if (type === "EmailMilestones") {
      return milestoneList?.map((item: any) => ({
        label: item?.milestone,
        value: item?.milestone,
      }));
    } else if (type === "Whatsapp") {
      return manageContactList
        ?.filter((item: any) => item.isActive && item?.whatappNumber !== ""&&item.allowedChannels.includes("whatsapp"))
        ?.map((item: any) => ({
          label: `${item?.salutation}. ${item?.name} (${item?.countryCode}${item?.whatappNumber}, ${item?.organizationName})`,
          value: item?.name,
        }));
    } else if (type === "WhatsappGroupName") {
      return whatsappGroupList?.map((item: any) => ({
        label: `${item?.name}`,
        value: item?.name,
      }));
    } else if (type === "Email") {
      return manageContactList
        ?.filter((item: any) => item.isActive && item?.email !== ""&&item.allowedChannels.includes("email"))
        ?.map((item: any) => ({
          label: `${item?.salutation}. ${item?.name} (${item?.email}, ${item?.organizationName})`,
          value: item?.name,
        }));
    } else if (type === "Tag") {
      return tagList?.map((item: any) => ({
        label: `${item?.name}`,
        value: item?.name,
      }));
    }
    else if (type === "GroupingMilestone") {
      return milestoneGrouppingList?.map((item: any) => ({
        label: `${item?.groupName}`,
        value: item?.groupName,
      }));

    }
    else if (headerCheck?.fieldType == "Dropdown List") {
      return headerCheck?.dropdownOptions?.map((item: any) => ({
        label: item,
        value: item,
      }))
    }
    else if (headerCheck?.fieldType == "Yes/No") {
      const yesNoOptions = ["Yes", "No"];
      return yesNoOptions?.map((item: any) => ({
        label: item,
        value: item,
      }))
    }
  };


  const handleChangeSelectedData = (option: any) => {
    const { type } = csvBulkShow;

    setCsvBulkShow((prev: any) => ({
      ...prev,
      [`selected${type}`]: csvBulkShow.type !== "Tag" ? option : [option],
    }));
  };
  const dialogHandleClose = () => {
    setErrorPoppup(false);
  };

  const handleCellEditToggle = () => {
    setIsEditable(!isEditable);
  };
  const closeDialogBoxSelect = () => {
    newController.abort();
    cancelRequest.current = false;
    setPopupOpen(false);
    setCustommFieldTypeIsDropdown(false);
    setShowError("");
  };

  useEffect(() => {
    let timer: ReturnType<typeof setTimeout>;
    if (successPoppup) {
      timer = setTimeout(() => {
        setSuccessPoppup(false);
      }, 2000);
    }
    return () => clearTimeout(timer);
  }, [successPoppup]);


  return (
    <>
      <ThemeProvider theme={defaultTheme}>
        <div className="whiteBox">
          <div className="cvsfileTittl w-full">
            <h2 className="flex font-bold text-base mb-4">
              <ShieldCheck className="text-yellow-500 mr-2" /> Please
              comply with the format prescribed in the template file
            </h2>
          </div>


          <div className="grid grid-cols-12 gap-4">
            <div className="col-span-12 lg:col-span-8 md:col-span-8 sm:col-span-12">
              <div>


                <div className="flex flex-col">
                  <div className="flex-wrap lg:flex  md:flex sm:flex flex-row items-center">
                    <div className="btnfilemain">
                      <Button
                        className="fileUploadd"
                        component="label"
                        role={undefined}
                        variant="contained"
                        tabIndex={-1}
                        startIcon={<CloudUploadIcon />}
                      >
                        Choose file
                        <VisuallyHiddenInput
                          type="file"
                          onChange={handleFileChange}
                          accept=".csv"
                        />
                      </Button>
                      <p className="text-sm text-gray-400 mt-1">
                        File format: CSV only
                      </p>
                    </div>
                    <div className="uploadinput">

                      {fileName && (
                        <Box>
                          <span>{fileName}</span>
                          <IconButton
                            size="small"
                            onClick={handleRemoveFile}
                            sx={{ marginLeft: 1 }}
                          >
                            <CloseIcon />
                          </IconButton>
                        </Box>
                      )}
                    </div>
                  </div>
                </div>

                <div className="flex mt-4 radtwobtn">
                  {showButton && (
                    <Button
                      className="btn btnTheme"
                      variant="contained"
                      onClick={async () => {
                        if (
                          (await handleReadClick("")) != null &&
                          !(await handleReadClick(""))
                        ) {
                          setAwbSubscriptionTemplate(true);
                        } else {
                          setAwbSubscriptionTemplate(false);
                        }
                      }}
                      style={{ whiteSpace: "nowrap" }}
                    >
                      Read
                    </Button>
                  )}

                  <Button
                    className="btn btnTheme btnGray"
                    variant="contained"
                    onClick={handleVerifyAndUploadClick}
                    disabled={!tableData.length}
                    style={{ whiteSpace: "nowrap" }}
                  >
                    Verify & Upload
                  </Button>
                </div>
              </div>
            </div>
            <div className="col-span-12 lg:col-span-4 md:col-span-4 sm:col-span-12">
              <div className="flex justify-start  lg:justify-end">
                <div className="block text-left lg:text-center md:text-center sm:text-left newfileuploadbtn drawerDownloadBtn">
                  <figure className="mb-4 text-center ">
                    <img
                      src="/images/downloadd.png"
                      alt="img"
                      className="inline-block"
                    />
                  </figure>
                  {/* <a href="/files/AWB_Bulk_Upload.csv" download> */}
                  <Button variant="contained" className="btn btnTheme" onClick={downloadCSV}>
                    Download Template
                  </Button>
                  {/* </a> */}
                </div>
              </div>
            </div>
          </div>

          <div className="tableupload">

            {tableData.length > 0 && showtable && (
              <TableContainer
                component={Paper}
                sx={{
                  marginTop: "20px",
                  boxShadow: "rgba(0, 0, 0, 0.20) 0px 3px 10px",
                }}
              >
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell sx={{ borderRight: "1px solid #ccc" }}>
                        Delete
                      </TableCell>
                      {csvTemplate &&
                        csvTemplate
                          .filter((item: string) => item !== "Template")
                          .map((item: string) => (
                            <TableCell key={item} sx={{ borderRight: "1px solid #ccc" }}>
                              {item}{(allField.find((field: any) => field.fieldName == item) || {required:false}).required && "*" }
                            </TableCell>
                          ))}
                     
                    </TableRow>
                  </TableHead>



                  <TableBody>
                    {tableData.map((row: any, rowIndex) => (
                      <TableRow key={rowIndex}>
                        <TableCell sx={{ borderRight: "1px solid #ccc" }}>
                          <IconButton onClick={() => handleDeleteRow(rowIndex)}>
                            <DeleteIcon />
                          </IconButton>
                        </TableCell>

                        {csvTemplate
                          .filter((field: string) => field !== "Template")
                          .map((field: string) => {
                            const errorStatus = row?.[`errorStatus${field}`];

                            return (
                              <TableCell
                                key={field}
                                onClick={() =>
                                  handleOpenPopup(
                                    row,
                                    field,
                                    row[field],
                                    errors[rowIndex]?.[`${field}Error`] || null,
                                    rowIndex
                                  )
                                }
                                sx={{
                                  borderRight: "1px solid #ccc",
                                  backgroundColor:
                                    errorStatus === "1" ? "#F05A7E" : // red for error
                                      errorStatus === "0" ? "#C0EBA6" : // green for valid
                                        "white", // default
                                  color: "#36454F",
                                  cursor: errorStatus === "1" ? "pointer" : "text",
                                }}
                              >
                                {row[field] || "-"}
                              </TableCell>
                            );
                          })}
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            )}
          </div>
        </div>
      </ThemeProvider>
      <Dialog open={popupOpen} onClose={closeDialogBoxSelect}>
        <DialogTitle>
          {selectedCell ? `Edit ${selectedCell.header}` : "Edit Cell"}
        </DialogTitle>
        <DialogContent>
          <Typography>
            {Object.entries(selectedRow || {})
              .map(([key, value]) => {
                if (!key.includes("errorStatus")) {
                  return `${key}: (${value})`;
                }
              })
              .join("  ")}
          </Typography>
          <Typography
            sx={{
              marginTop: "20px",
              fontSize: "16px",
              color: "red",
              minHeight: "30px",
            }}
          >
            <p>{showError !== undefined ? showError || "" : "NO Error"}</p>

          </Typography>
          <Box sx={{ height: "50vh" }}>
           
            {
              currentFieldType == "Date" ? <input type="date" value={selectedCell.value} onChange={(e) => setSelectedCell((prev) => ({ ...prev, value: e.target.value }))} /> : (
                selectedCell.header == "AWB" || currentFieldType == "Text Box" || currentFieldType == "Number" ? (<TextField
                  fullWidth
                  value={selectedCell.value}
                  onChange={(e) =>
                    setSelectedCell((prev) => ({
                      ...prev,
                      value: e.target.value,
                    }))
                  }
                  margin="dense"
                />) : <Select
                  isMulti={
                    csvBulkShow.type !== "Tag" &&
                    csvBulkShow.type !== "GroupingMilestone" &&
                    !allField.find((item: any) => item.fieldType === currentFieldType)
                  }
                  isDisabled={editable}
                  name="milestone"
                  options={handleSelectedCellData()}
                  className="basic-multi-select"
                  classNamePrefix="select"
                  value={csvBulkShow[`selected${csvBulkShow.type}`]}
                  onChange={handleChangeSelectedData}
                  styles={{
                    control: (base: any) => ({
                      ...base,
                      backgroundColor: "#f0f0f0",
                      border: "none",
                      boxShadow: "none",
                      "&:hover": {
                        border: "none",
                      },
                    }),
                    placeholder: (base: any) => ({
                      ...base,
                      color: "#999",
                    }),
                  }}
                />
              )
            }

          </Box>
        </DialogContent>

        <DialogActions>
          <Button onClick={closeDialogBoxSelect}>Close</Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={successPoppup}
        onClose={() => setSuccessPoppup(false)}
        maxWidth="sm"
        fullWidth
      >
        <DialogContent sx={{ textAlign: "center", padding: "40px" }}>
          <DialogTitle sx={{ fontWeight: "bold", fontSize: "24px" }}>
            Success
          </DialogTitle>

          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              marginTop: "20px",
            }}
          >
            <CheckCircleIcon sx={{ fontSize: 60, color: "#8BC34A" }} />
          </Box>

          <Typography
            variant="body1"
            sx={{ marginTop: "20px", fontSize: "18px" }}
          >
            Success!
          </Typography>
        </DialogContent>
      </Dialog>

      <Dialog
        open={errorPoppup}
        onClose={() => setErrorPoppup(false)}
        maxWidth="sm"
        fullWidth
      >
        <DialogContent sx={{ textAlign: "center", padding: "40px" }}>
          <DialogTitle sx={{ fontSize: "22px", color: "red" }}>
            <p>{error}</p>
          </DialogTitle>

          <Typography
            variant="body1"
            sx={{ marginTop: "20px", fontSize: "16px", color: "red" }}
          >
            {failedPoppup.length > 0 && (
              <ul>
                {failedPoppup.map((item: any, index: any) => (
                  <li key={index}>
                    {item.AWB} - {item.reason}
                  </li>
                ))}
              </ul>
            )}
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={dialogHandleClose}>Close</Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={awbSubscriptionTemplate}
        onClose={() => setAwbSubscriptionTemplate(false)}
        maxWidth="sm"
        fullWidth
      >
        <DialogContent sx={{ textAlign: "center", padding: "40px" }}>
          <DialogTitle sx={{ fontWeight: "bold", fontSize: "24px" }}>
            Some of the AWBs have both, Subscription Template and Manual
            Subscription Details added. Do you wish to combine both?
          </DialogTitle>
        </DialogContent>
        <DialogActions sx={{ justifyContent: "center", paddingBottom: "20px" }}>
          <Button
            variant="contained"
            color="primary"
            value="combineboth"
            onClick={() => {
              handleReadClick("combineboth");
              setShowtable(1);
            }}
          >
            Yes, combine both
          </Button>
          <Button
            variant="contained"
            color="primary"
            value="keeptemplateonly"
            onClick={() => handleReadClick("keeptemplateonly")}
          >
            No, keep template only
          </Button>
          <Button
            variant="contained"
            color="primary"
            value="keepmanualdetailsonly"
            onClick={() => handleReadClick("keepmanualdetailsonly")}
          >
            No, keep manual details only
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}

export default BulkUploadAWB;
